import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n";
import { scrollToId } from "@/components/Reveal";

export const Footer = () => {
    const { t } = useLanguage();
    return (
        <footer data-testid="site-footer" className="border-t border-white/10 bg-[#151921]">
            <div className="mx-auto max-w-[1600px] px-5 py-16 md:px-12 lg:px-24">
                <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
                    <div>
                        <img src="/assets/logo-white.png" alt="Midora Atelier Gastronomico" className="h-14 w-auto" data-testid="footer-logo" />
                        <p className="mt-6 max-w-sm text-sm italic leading-relaxed text-[#DBD1BD]/50" data-testid="footer-tagline">
                            {t("footer.tagline")}
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
                        <button data-testid="footer-nav-about" onClick={() => scrollToId("chi-siamo")} className="text-left transition-colors duration-300 hover:text-white">{t("nav.about")}</button>
                        <button data-testid="footer-nav-products" onClick={() => scrollToId("prodotti")} className="text-left transition-colors duration-300 hover:text-white">{t("nav.products")}</button>
                        <button data-testid="footer-nav-why" onClick={() => scrollToId("perche-noi")} className="text-left transition-colors duration-300 hover:text-white">{t("nav.why")}</button>
                        <button data-testid="footer-nav-contacts" onClick={() => scrollToId("contatti")} className="text-left transition-colors duration-300 hover:text-white">{t("nav.contacts")}</button>
                        <Link to="/privacy" data-testid="footer-privacy-link" className="text-left transition-colors duration-300 hover:text-white">{t("cookie.policy")}</Link>
                    </div>
                    <div className="font-mono text-[10px] uppercase leading-loose tracking-[0.2em] text-white/40">
                        <p>Via Privata Oslavia 17/3 C — Milano</p>
                        <p><a href="tel:+393393506050" data-testid="footer-phone-link" className="transition-colors duration-300 hover:text-midora-red">+39 339 350 6050</a></p>
                        <p><a href="mailto:info@midoraatelier.com" data-testid="footer-email-link" className="transition-colors duration-300 hover:text-midora-red">info@midoraatelier.com</a></p>
                    </div>
                </div>
                <div className="mt-14 border-t border-white/5 pt-6">
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/30" data-testid="footer-rights">
                        {t("footer.rights")}
                    </p>
                </div>
            </div>
        </footer>
    );
};
